export const DEFAULT_TICK_COUNT = 40;

export const DEFAULT_SIZE = 220;

export const DEFAULT_ANIMATION_DURATION = 1000;

export const DEFAULT_TICK_GAP = 0.3;

// Use Design System color tokens only
// Using data visualization tokens for better visibility
export const DEFAULT_FILLED_COLOR = 'var(--sodRadialGauge-filledColor-start)';
export const DEFAULT_FILLED_COLOR_END = 'var(--sodRadialGauge-filledColor-end)';

export const DEFAULT_UNFILLED_COLOR =
  'var(--color-border-neutral-subtle, #495473)';
export const MIN_SIZE_FOR_LABEL = 120;

/** Geometry ratios — all relative to size */
export const GEOMETRY = {
  centerYRatio: 0.55,
  innerRadiusRatio: 0.32,
  tickLengthRatio: 0.085,
  svgHeightRatio: 0.65,
  valueFontSizeRatio: 0.14,
  strokeWidthRatio: 0.018,
  valueYOffset: 8,
} as const;

/** Max allowed tickGap before ticks become invisible */
export const MAX_TICK_GAP = 0.9;
